import { createFileRoute } from '@tanstack/react-router'
import { ConsumptionPage } from '../../modules/consumption'

export const Route = createFileRoute('/_app/consumption')({
  component: ConsumptionPage,
})
